// --
import React from 'react';
import Icon from "../icon/FAIcon";
import "./Image.scss";
import AbstractReactComponent from "../AbstractReactComponent";
import classNames from 'classnames';

/**
 * Komponenta obrázku s možností jednu vybrat kliknutím na checkbox.
 */
class Image extends AbstractReactComponent {
    static PropTypes = {
        src: React.PropTypes.string,
        checked: React.PropTypes.bool,
        onCheck: React.PropTypes.func,  // klik na checkbox
        onClick: React.PropTypes.func,   // klik na obrázek - např. pro možnost akce zobrazení náhledu apod.
        renderItem: React.PropTypes.func,   // render obrázku, pokud je potřeba jiný než standardní
        disabled: React.PropTypes.bool,   // je disabled
        imgProps: React.PropTypes.object,   // props pro img element
    };

    static defaultProps = {
    };

    render() {
        const {imgProps, className, disabled, checked, onCheck, renderItem, onClick, src} = this.props;

        const clsCont = classNames(
            "image-container",
            className, {
                disabled
            }
        );


        return <div className={clsCont} onClick={onClick}>
            <div className={"check p-2 fa-stack fa-sm" + (checked ? " active" : "")} onClick={disabled ? ()=>{} : e => {e.stopPropagation();onCheck(e);}}>
                {checked && <Icon fixedWidth className={"fa-stack-2x"} icon="circle" />}
                <Icon fixedWidth className={checked ? "fa-stack-1x" : "fa-stack-2x"} icon={checked ? "check" : "circle-o"} />
            </div>
            {renderItem ? renderItem(src, checked) : <img {...imgProps}  src={src}/>}
        </div>;
    }
}

export default Image;
